<div class="social-login-header">
	<span></span>
	<span i18n="@@authentication.connect-with" class="social-login-title"> Se connecter avec </span>
	<span></span>
</div>

<div class="social-login">
	<button (click)="loginWithGoogle()" class="social-login-button">
		<img
			i18n-alt="@@authentication.login-with-google.alt"
			alt="Log in with Google"
			class="no-save"
			src="/assets/auth/images/google-button.png"
			draggable="false"
		/>
	</button>

	@if (appConfigService.getClientApp() !== 'android') {
		<button (click)="loginWithApple()" class="social-login-button">
			<img
				i18n-alt="@@authentication.login-with-apple.alt"
				alt="Log in with Apple"
				class="no-save"
				src="/assets/auth/images/apple-button.png"
				draggable="false"
			/>
		</button>
	}
</div>
